/**
 * ProtectedRoute.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // console.log('🔒 ProtectedRoute: Checking authentication...', { isAuthenticated, isLoading }); // Commented out to reduce console noise

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh'
      }}>
        <LoadingSpinner size="medium" message="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnPath = `${location.pathname}${location.search}${location.hash}`;
    return (
      <Navigate
        to={{ pathname: '/login', search: `?returnUrl=${encodeURIComponent(returnPath)}` }}
        replace
        state={{ from: location }}
      />
    );
  }

  // console.log('✅ ProtectedRoute: User authenticated, allowing access'); // Commented out to reduce console noise
  return children;
};

export default ProtectedRoute; 